import React, {useEffect, useState} from 'react';
import {Button, Nav, Navbar} from "react-bootstrap";
import {withRouter} from "react-router";
import Sticky from 'react-stickynode';
import {connect} from "react-redux";

import BorderButton from "../BorderButton/index.b";
import {accountModal, showUpgradeModal, toggleTeamModal} from "../../Manage/actions";
import {PLANS} from "../../constants/plans";

import './HomeHeader.css';

const onManageClick = (history) => {
  if (localStorage.getItem('token')) {
    history.push('/manage');
  } else {
    history.push('/login');
  }
};

const logout = (history) => {
  localStorage.removeItem('token');
  history.push('/login');
};

const ManageAccountButtons = ({ dispatch, isChildAccount, onAddTeam }) =>
  <>
    {!isChildAccount && <button
      className="home-header-account"
      onClick={onAddTeam}
    >
      <img style={{ opacity: 0.5 }} className="me-2" src="assets/icons/add-user.png" height={15} />
      Add team
    </button>}
    <button
      className="home-header-account"
      onClick={() => dispatch(accountModal(true))}
    >
      Manage account
    </button>
  </>;

const UpgradeButton = ({dispatch}) =>
  <div
    className="home-header-account bg-purple-light white"
    onClick={() => dispatch(showUpgradeModal(true))}
  >
    Upgrade for more
  </div>;

const getAccountButton = (trialAccount, isChildAccount, dispatch, onAddTeam) => {
  if (trialAccount) {
    return <UpgradeButton dispatch={dispatch}/>
  } else if (isChildAccount) {
    return null;
  } else {
    return <ManageAccountButtons
      dispatch={dispatch}
      isChildAccount={isChildAccount}
      onAddTeam={onAddTeam}
    />
  }
}

const HomeHeader = ({dispatch, history, proMode, productId, isLoading, isChildAccount, showUpgradePayModal}) => {
  const [sticky, setSticky] = useState(false);
  const [showCTA, setShowCTA] = useState(false);

  const trialAccount = !productId;

  const handleStateChange = (status) => {
    setSticky(status.status === Sticky.STATUS_FIXED);
  };

  const onScroll = () => {
    setShowCTA(window.pageYOffset > window.innerHeight - (window.innerHeight * 0.5));
  };

  useEffect(() => {
    if (window.location.pathname === '/') {
      window.addEventListener('scroll', onScroll);
      return () => window.removeEventListener('scroll', onScroll);
    }
  }, []);

  const onAddTeam = () => {
    if (productId === PLANS.PRO_U.id) {
      dispatch(toggleTeamModal(true))
    } else {
      showUpgradePayModal()
    }
  };

  return (
    <Sticky innerClass={sticky ? 'sticky' : ''} onStateChange={handleStateChange} innerZ={999}>
      <Navbar bg="transparent" expand="lg" collapseOnSelect className={sticky ? 'pt-2' : ''}>
        <Navbar.Toggle className="ms-3" aria-controls="responsive-navbar-nav"/>
        <Navbar.Brand className="d-l-none d-block" href="/">
          <img
            className="home-header-logo"
            src="/assets/logo.png"
            alt="tiny.host"
            onClick={() => history.push('/')}
          />
        </Navbar.Brand>
        {!proMode && <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="ms-l-3">
            <Nav.Link className="menu-link" href="/blog/">Blog</Nav.Link>
            <Nav.Link className="menu-link" onClick={() => history.push('/help/#faq')}>FAQ</Nav.Link>
            <Nav.Link className="menu-link" onClick={() => history.push('/pricing')}>Pricing</Nav.Link>
          </Nav>
        </Navbar.Collapse>}
        <Navbar.Brand className="d-none d-l-block" href="/">
          <img
            className="home-header-logo"
            src="/assets/logo.png"
            alt="tiny.host"
            onClick={() => history.push('/')}
          />
        </Navbar.Brand>
        {showCTA && <div className="upload-cta swing-in-top-fwd p-2">
          <Button
            onClick={() => window.scrollTo(0, 0)}
          >
            Upload Site
          </Button>
        </div>}
        <Navbar.Collapse id="responsive-navbar-nav" >
          {!proMode && <Nav className="me-auto"/>}
          {proMode ?
              <>
                <Nav className="me-auto" activeKey="/none">
                  <Nav.Item>
                    <Nav.Link className="header-link op-7 float-left" onClick={() => window.$crisp.push(['do', 'chat:open'])}>
                      Live chat
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link className="header-link op-7 float-left" target="_blank" href="/documentation">
                      Documentation
                    </Nav.Link>
                  </Nav.Item>
                </Nav>
                <Nav>
                  {!isLoading && <Nav.Link className="pe-0">
                    {getAccountButton(trialAccount, isChildAccount, dispatch, onAddTeam)}
                  </Nav.Link>}
                  <Nav.Link className="d-flex align-items-center m-auto" onClick={() => logout(history)}>
                    <BorderButton
                      label="Log out"
                    />
                  </Nav.Link>
                </Nav>
              </>
              :
              <Nav>
                <Nav.Link onClick={() => onManageClick(history)} className="menu-link">
                  Log in
                </Nav.Link>
                <Nav.Link onClick={() => onManageClick(history)}>
                  <BorderButton label="Sign up free"/>
                </Nav.Link>
              </Nav>}
        </Navbar.Collapse>
      </Navbar>
    </Sticky>)
};

const mapDispatchToProps = (dispatch) => ({dispatch});
const mapStateToProps = (state) => ({
  productId: state.manage.userProfile.productId,
  isLoading: !state.manage.userProfile.email,
  isChildAccount: !!state.manage.userProfile.childAccount,
  email: state.manage.userProfile.email
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(HomeHeader));
